import React from 'react'
import { Box, styled } from '@mui/material'
import RelatedReports from '../relatedReports/RelatedReports'
import { isEmpty } from 'src/utils'

/**
 * Related Reports Container
 * theme path: RelatedReports.styleOverrides.container
 */
const RelatedContainer = styled(Box, {
  name: 'RelatedReports',
  label: 'relatedReportsContainer',
  overridesResolver: (props, styles) => [styles.container]
})(({ theme }) => ({
  margin: '7px 0px 10px',
  padding: '15px 16.556px 10px 16.556px',
  backgroundColor: '#EFF4FF',
  borderRadius: '30px',
  border: 'var(--stroke-weight-1, 1px) solid var(--color-blue-88, #D5D9EB)',
  boxShadow:
    '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)'
}))

const RelatedMessage = ({ show, relatedReports }) => {
  if (isEmpty(relatedReports) || !show) return <></>
  return (
    <RelatedContainer data-testid="related-message">
      {!isEmpty(relatedReports) && <RelatedReports articles={relatedReports} />}
    </RelatedContainer>
  )
}

export default RelatedMessage
